import { Chevron } from '@ahamove/icons';
import { Group, Stack, Text, Title, Pill, rem } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { openContextModal } from '@mantine/modals';
import BikePackageIcon from '@/assets/icons/bike-package-icon.svg';
import InfoTooltip from '@/components/info-tooltip';
import { ModalName } from '@/components/modals';
import { useBookingStore } from '@/stores/booking/booking-store-provider';

interface BikePackageHeaderProps {
  isOpen: boolean;
  onToggle: () => void;
}

const BikePackageHeader = ({ isOpen, onToggle }: BikePackageHeaderProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { bikePackageSize, bikePackageWeight, itemDescriptions } =
    useBookingStore((state) => state);

  const handleShowInfo = () => {
    openContextModal({
      modal: ModalName.GoodsInfor,
      innerProps: {},
      h: 'fit-content',
      closeOnClickOutside: false,
      withCloseButton: false,
      centered: true,
      maw: rem(440),
      w: '100%',
      styles: {
        root: { zIndex: 1001 },
        inner: {
          padding: 0,
          overflow: 'hidden',
        },
        content: {
          backgroundColor: 'white',
          overflow: 'hidden',
          margin: rem(16),
          maxWidth: `calc(100% - ${rem(32)})`,
        },
        body: {
          position: 'relative',
          padding: rem(16),
          paddingTop: rem(48),
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'var(--stack-align, stretch)',
          justifyContent: 'var(--stack-justify, flex-start)',
          maxHeight:
            'var(--modal-content-max-height, calc(100dvh - var(--modal-y-offset) * 2))',
        },
      },
    });
  };

  return (
    <Group
      justify="space-between"
      className="relative w-full cursor-pointer"
      onClick={onToggle}
      gap={0}
      wrap="nowrap"
      p="md"
    >
      <BikePackageIcon className="size-6 md:size-8" viewBox="0 0 32 32" />

      <Stack gap={4} className="mx-3 grow overflow-hidden">
        <Group gap={8} wrap="nowrap">
          <Stack gap={4} className="overflow-hidden">
            <Title
              order={isMobile ? 6 : 4}
              style={{
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              <Text fw={700} size={isMobile ? 'sm' : 'lg'}>
                Thông tin hàng hóa{' '}
                <Text component="span" c="red">
                  *
                </Text>
              </Text>
            </Title>
          </Stack>
          <InfoTooltip
            multiline
            maw={300}
            className="shrink-0 self-center"
            onClick={(e) => {
              e.stopPropagation();
              handleShowInfo();
            }}
            label={'Thông tin hàng hóa'}
          />
        </Group>
        {!isOpen ? (
          <Group gap={4} className="overflow-hidden">
            <Pill
              fw={600}
              bg="neutral.1"
              h="fit-content"
              w="fit-content"
              c="neutral.7"
              radius={2}
              className="shrink-0"
            >
              {bikePackageSize}
            </Pill>
            <Pill
              fw={600}
              bg="neutral.1"
              h="fit-content"
              w="fit-content"
              c={bikePackageWeight ? 'neutral.7' : 'neutral.5'}
              radius={2}
              className="shrink-0"
            >
              {bikePackageWeight ? `${bikePackageWeight}kg` : 'Khối lượng'}
            </Pill>
            {itemDescriptions && itemDescriptions.length > 0 ? (
              itemDescriptions.map((item) => (
                <Pill
                  fw={600}
                  h="fit-content"
                  w="fit-content"
                  c="neutral.7"
                  bg="neutral.1"
                  radius={2}
                  key={item.code}
                  className="shrink-0"
                >
                  {item?.keyword}
                </Pill>
              ))
            ) : (
              <Pill
                fw={600}
                h="fit-content"
                w="fit-content"
                c="neutral.5"
                bg="neutral.1"
                radius={2}
                className="shrink-0"
              >
                Loại hàng hóa
              </Pill>
            )}
          </Group>
        ) : null}
      </Stack>

      <Chevron
        style={{
          flex: 'none',
          transform: isOpen ? 'rotate(-90deg)' : 'rotate(90deg)',
          transition: 'transform 200ms ease',
        }}
        className="size-4 shrink-0 md:size-6"
      />
    </Group>
  );
};

export default BikePackageHeader;
